<div class="nav-header" [ngClass]="{'collapsed': (collapsed$ | async)}">
	<div class="logo-container">
		<img
			class="logo"
			alt="GoReact"
			src="https://staticassets.goreact.com/logo-goreact-dash-2022.svg">
		<div *ngIf="isLTI" class="lti-version">
			<span [attr.aria-label]="'logo-version' | translate : { versionNumber: version }">
				{{ version }}
			</span>
		</div>
	</div>
</div>
<div class="nav-body">
	<div class="nav-tree" *ngIf="orgs?.length > 0 && (collapsed$ | async) === false">
		<a
			*ngFor="let org of orgs | alphabeticalByKey:'name'"
			class="org nav-link"
			[ngClass]="{'selected': org.group_id === selectedService.getOrg()?.group_id && !nonFolderStates.includes(transitionState$ | async)}"
			(keyup.enter)="goToOrg(org)"
			(click)="goToOrg(org)"
			data-cy="org-link"
			[matTooltip]="org.name">
			<span tabindex="0">{{org.name}}</span>
			<button
				*ngIf="canInvite(org)"
				mat-icon-button
				class="invite-btn"
				data-cy="invite-org"
				[attr.aria-label]="'course-menu_invite-org-users' | translate"
				(click)="openInviteModal($event, org)">
				<mat-icon class="ficon-add-user"></mat-icon>
			</button>
		</a>
	</div>
	<div class="nav-content">
		<a
			*ngIf="(collapsed$ | async) === false"
			class="archive nav-link"
			[ngClass]="{'selected': (transitionState$ | async) === states.DASHBOARD_ARCHIVE}"
			tabindex="0"
			data-cy="archive-link"
			(click)="goToArchive()"
			(keyup.enter)="goToArchive()"
			translate>
			common_archive
		</a>
		<featured-message *ngIf="shouldShowFeaturedMessage$ | async"></featured-message>
	</div>
</div>
<div class="nav-bottom" [ngClass]="{'collapsed': (collapsed$ | async)}">
	<a
		*ngIf="shouldShowFeatureFlags()"
		class="feature-flags nav-link"
		tabindex="0"
		[matTooltip]="'feature-flags' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="openFeatureFlags()"
		(keyup.enter)="openFeatureFlags()">
		<i class="ficon-flag-o"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>feature-flags</span>
	</a>
	<a
		*ngIf="shouldShowHeyGen()"
		class="heygen nav-link"
		tabindex="0"
		[matTooltip]="'heygen-editor' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="openHeyGen()"
		(keyup.enter)="openHeyGen()">
		<i class="ficon-puzzle-piece"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>heygen-editor</span>
	</a>
	<a
		*ngIf="shouldShowLicenseManagement()"
		class="license nav-link"
		[ngClass]="{'selected': licenseStates.includes(transitionState$ | async)}"
		tabindex="0"
		[attr.aria-label]="'license-management' | translate"
		[matTooltip]="'license-management' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="goToLicense()"
		(keyup.enter)="goToLicense()">
		<i class="ficon-edit-list"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>license-management</span>
	</a>
	<a
		*ngIf="shouldShowLibraryButton()"
		class="library nav-link"
		tabindex="0"
		data-cy="library-button"
		[attr.aria-label]="'common_library' | translate"
		[matTooltip]="'common_library' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="openLibrary()"
		(keyup.enter)="openLibrary()">
		<i class="ficon-app-library"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>common_library</span>
	</a>
	<a
		*ngIf="!isLTI"
		class="help nav-link"
		tabindex="0"
		[matTooltip]="'help_feedback' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="activateZendeskWidget()"
		(keyup.enter)="activateZendeskWidget()"
		analytics-on="click"
		analytics-category="Zendesk"
		analytics-event="Help!"
		aria-haspopup="dialog"
		[attr.aria-label]="'help_feedback' | translate"
	>
		<i class="ficon-app-help-circle-outline"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>help_feedback</span>
	</a>
	<a
		*ngIf="shouldShowCustomParams()"
		class="custom-params nav-link"
		tabindex="0"
		[matTooltip]="'custom-params' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		[attr.aria-label]="'custom-params' | translate"
		(click)="openCustomParamsModal()"
		(keyup.enter)="openCustomParamsModal()">
		<i class="ficon-app-help-circle-outline"></i>
		<span *ngIf="(collapsed$ | async) === false" translate>custom-params</span>
	</a>
	<a
		*ngIf="!(isLTI && whiteLabel)"
		class="give-feedback nav-link"
		tabindex="0"
		[matTooltip]="'customer-feedback-navigation-label' | translate"
		[matTooltipDisabled]="(collapsed$ | async) === false"
		(click)="openFeedbackSnackbar()"
		(keyup.enter)="openFeedbackSnackbar()"
		[attr.aria-label]="'customer-feedback-navigation-label' | translate"
		analytics-on="click"
		analytics-category="Feedback"
		analytics-event="Give feedback!"
		aria-haspopup="dialog"
	>
		<i class="ficon-pointy-star"></i>
		<span *ngIf="(collapsed$ | async) === false" class="give-feedback-label" translate>customer-feedback-navigation-label</span>
	</a>
</div>
